import { createSelector } from 'reselect'
import { filterStoreBySegments } from '../utils'

export const viewSelector = createSelector(
  (state) => state.app.view,
  (state) => state,
)

export const selectSnack = createSelector(
  (state) => state.snack,
  (snack) => snack,
)

export const selectDialog = createSelector(
  (state) => state.dialog,
  (state) => state.config.showContextViewStore,
  (dialog) => dialog,
)

export const selectProducts = createSelector(
  (state) => state.app.products,
  (state) => state.app.productsLoading,
  (state) => state.app.searchProductResults,
  (state) => state.app.searchLoading,
  (state) => state.app.selected,
  (state) => state.config,
  (products, loading, searchProductResults, loadingSearch, selected, config) => {
    return {
      searchProductResults,
      products,
      fromSearch: !!searchProductResults,
      loading: loadingSearch || loading,
      selected,
      config,
    }
  },
)

export const selectStores = createSelector(
  (state) => state.app.stores,
  (state) => state.app.selectedSegments,
  (state) => state.app.selected,
  (state) => state.app.storesLoading,
  (state) => state.app.currentStore,
  (state) => state.app.showStoreInformation,
  (state) => state.app.isMobileStoreInformationsFullHeight,
  (
    stores,
    selectedSegments,
    selectedProducts,
    loading,
    currentStore,
    showStoreInformation,
    isMobileStoreInformationsFullHeight,
  ) => {
    return {
      stores: filterStoreBySegments(stores, selectedSegments),
      selectedProducts,
      loading,
      currentStore,
      showStoreInformation,
      isMobileStoreInformationsFullHeight,
    }
  },
)

export const selectMap = createSelector(
  (state) => state.app.user,
  (state) => state.app.mapState,
  (state) => state.app.stores,
  (state) => state.app.selectedSegments,
  (state) => state.app.customLocation,
  (state) => state.app.currentStore,
  (state) => state.app.view,
  (state) => state.app.mobileBottomShow,
  (state) => state.app.segmentation,
  (user, mapState, stores, selectedSegments, customLocation, currentStore, view, showBottom, segmentation) => {
    return {
      user,
      ...mapState,
      stores: filterStoreBySegments(stores, selectedSegments),
      customLocation,
      currentStore,
      view,
      showBottom,
      segmentation,
    }
  },
)

export const selectSearchField = createSelector(
  (state) => state.app.q,
  (state) => state.app.searchLoading,
  (state) => state.app.searchProductResults,
  (state) => state.config.searchPlaceholder,
  (q, loading, searchProductResults, placeholder) => ({
    q,
    canBack: !!searchProductResults,
    loading,
    placeholder,
  }),
)

export const selectPosition = createSelector(
  (state) => state.position,
  (...args) => args,
)

export const selectChart = createSelector(
  (state) => state.chart,
  (...args) => args,
)

export const selectSegmentation = createSelector(
  (state) => state.app.segmentation,
  (segmentation) => segmentation,
)

export const selectSelectedSegments = createSelector(
  (state) => state.app.selectedSegments,
  (selectedSegments) => selectedSegments,
)
